import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSmile, faPaintBrush, faCut, faFlask, faCapsules,
  faMobileAlt, faLaptop, faClock, faDesktop, faTv, faTabletAlt, faMoneyBill1Wave
} from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

const categories = [
  { path: '/most-discounted', icon: faMoneyBill1Wave, label: 'banner.buttonText' }, // Translates from i18n path
  { path: '/skincare', icon: faSmile, label: 'menuModal.categories.skincare' },
  { path: '/makeup', icon: faPaintBrush, label: 'menuModal.categories.makeup' },
  { path: '/haircare', icon: faCut, label: 'menuModal.categories.haircare' },
  { path: '/fragrances', icon: faFlask, label: 'menuModal.categories.fragrances' },
  { path: '/supplements', icon: faCapsules, label: 'menuModal.categories.supplements' },
  { path: '/phones', icon: faMobileAlt, label: 'menuModal.categories.phones' },
  { path: '/smartwatches', icon: faClock, label: 'menuModal.categories.smartwatches' },
  { path: '/tablets', icon: faTabletAlt, label: 'menuModal.categories.tablets' },
  { path: '/laptops', icon: faLaptop, label: 'menuModal.categories.laptops' },
  { path: '/tvs', icon: faTv, label: 'menuModal.categories.tvs' },
  { path: '/monitors', icon: faDesktop, label: 'menuModal.categories.monitors' },
];

const SexyCategoryBar = () => {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <div className="sticky top-[60px] z-40 bg-white/70 backdrop-blur-md shadow-sm border-b border-base-200 dark:border-white">
      <div className="max-w-7xl mx-auto">
        <div className="flex gap-3 overflow-x-auto px-4 py-3 snap-x snap-mandatory scroll-smooth no-scrollbar justify-start sm:justify-center">
          {categories.map(({ path, icon, label }) => {
            const isActive = location.pathname.startsWith(path);

            const linkClasses =
              'flex flex-col items-center justify-center min-w-[72px] px-2 py-1 snap-start transition-transform duration-300 ease-in-out hover:scale-105 active:scale-95 ' +
              'rounded-2xl border border-transparent bg-white/60 hover:bg-white/80 shadow-md backdrop-blur-md ' +
              (isActive ? 'ring-2 ring-primary text-primary font-semibold shadow-lg' : '');

            const iconClasses =
              'text-lg mb-1 transition-all duration-300 ' +
              (isActive ? 'text-primary scale-110' : '');

            return (
              <Link to={path} key={label} className={linkClasses}>
                <FontAwesomeIcon icon={icon} className={iconClasses} />
                <span className="text-center text-[12px] sm:text-xs">{t(label)}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SexyCategoryBar;


// import React from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import {
//   faSmile, faPaintBrush, faCut, faFlask, faCapsules,
//   faMobileAlt, faLaptop, faClock, faDesktop, faTv, faTabletAlt
// } from '@fortawesome/free-solid-svg-icons';
// import { useTranslation } from 'react-i18next';

// const categories = [
//   { path: '/skincare', icon: faSmile, label: 'skincare' },
//   { path: '/makeup', icon: faPaintBrush, label: 'makeup' },
//   { path: '/haircare', icon: faCut, label: 'haircare' },
//   { path: '/fragrances', icon: faFlask, label: 'fragrances' },
//   { path: '/supplements', icon: faCapsules, label: 'supplements' },
//   { path: '/phones', icon: faMobileAlt, label: 'phones' },
//   { path: '/smartwatches', icon: faClock, label: 'smartwatches' },
//   { path: '/tablets', icon: faTabletAlt, label: 'tablets' },
//   { path: '/laptops', icon: faLaptop, label: 'laptops' },
//   { path: '/tvs', icon: faTv, label: 'tvs' },
//   { path: '/monitors', icon: faDesktop, label: 'monitors' },
// ];

// const SexyCategoryBar = () => {
//   const { t } = useTranslation();
//   const location = useLocation();

//   return (
//     <div className="sticky top-[64px] z-40 bg-white/70 backdrop-blur-md shadow-sm border-b border-base-200 dark:border-white">
//       <div className="flex gap-3 overflow-x-auto px-4 py-3 snap-x snap-mandatory scroll-smooth no-scrollbar">
//         {categories.map(({ path, icon, label }) => {
//           const isActive = location.pathname.startsWith(path);

//           const linkClasses =
//             'flex flex-col items-center justify-center min-w-[72px] px-2 py-1 snap-start transition-transform duration-300 ease-in-out hover:scale-105 active:scale-95 ' +
//             'rounded-2xl border border-transparent bg-white/60 hover:bg-white/80 shadow-md backdrop-blur-md ' +
//             (isActive ? 'ring-2 ring-primary text-primary font-semibold shadow-lg' : '');

//           const iconClasses =
//             'text-lg mb-1 transition-all duration-300 ' +
//             (isActive ? 'text-primary scale-110' : '');

//           return (
//             <Link to={path} key={label} className={linkClasses}>
//               <FontAwesomeIcon icon={icon} className={iconClasses} />
//               <span className="text-[12px] sm:text-xs">
//                 {t(`menuModal.categories.${label}`)}
//               </span>
//             </Link>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// export default SexyCategoryBar;